export interface FilterVisibility {
  show: boolean;
  mode?: "single" | "multi";
  type?: "select" | "date" | "text";
}

export interface showFilters {
  year?: FilterVisibility;
  date?: FilterVisibility;
  dateType?: FilterVisibility;
  mapType?: FilterVisibility;
  location?: {
    country?: FilterVisibility;
    state?: FilterVisibility;
    city?: FilterVisibility;
    locality?: FilterVisibility;
  };
  user?: FilterVisibility;
  lead?: FilterVisibility;
  tag?: FilterVisibility;
  status?: FilterVisibility;
  source?: FilterVisibility;
  stage?: FilterVisibility;
  leadType?: FilterVisibility;
  territory?: FilterVisibility;
  referral?: FilterVisibility;
  createdBy?: FilterVisibility;
  assignedTo?: FilterVisibility;
  statusType?: FilterVisibility;
  minAmount?: FilterVisibility;
  maxAmount?: FilterVisibility;
  category?: FilterVisibility;
  distributor?: FilterVisibility;
  retailer?: FilterVisibility;
  productStatus?: FilterVisibility;
  orderNumber?: FilterVisibility;
  manager?: FilterVisibility;
  role?: FilterVisibility;
  department?: FilterVisibility;
  designation?: FilterVisibility;
  branch?: FilterVisibility;
  qualification?: FilterVisibility;
  geoFenceType?: FilterVisibility;
  geoFenceName?: FilterVisibility;
  group?: FilterVisibility;
  byLeadStatus?: FilterVisibility;
  type?: FilterVisibility;
  locationId?: FilterVisibility;
  locationType?: FilterVisibility;
  leadContacts?: FilterVisibility;
  designationId?: FilterVisibility;
  item?: FilterVisibility;
  returnDate?: FilterVisibility;
  allocatedDate?: FilterVisibility;
  separationMode?: FilterVisibility;
  leaveType?: FilterVisibility;
  meetingType?: FilterVisibility;
  oldDeviceType?: FilterVisibility;
  newDeviceType?: FilterVisibility;
  taskType?: FilterVisibility;
  dueDate?: FilterVisibility;
  userGeofenceStatus?: FilterVisibility;
  settingType?: FilterVisibility;
  trackingStatus?: FilterVisibility;
}

export interface list {
  userList?: any[];
  tagList?: any[];
  customerList?: any[];
  width?: string;
  statusList?: any[];
  sourceList?: any[];
  stageList?: any[];
  typeList?: any[];
  territoryList?: any[];
  referralList?: any[];
  createdByList?: any[];
  assignedToList?: any[];
  countryList?: any[];
  categoryList?: any[];
  distributorList?: any[];
  managerList?: any[];
  departmentList?: any[];
  designationList?: any[];
  branchList?: any[];
  roleList?: any[];
  qualificationList?: any[];
  geoFenceList?: any[];
  groupList?: any[];
  separationMode?: any[];
  leaveTypeList?: any[]
  leadStatusList?: any[];
  locationList?: any[];
  locationTypeList?: any[];
  contactList?: any[];
  assetItemList?: any[];
  meetingTypeList?: any[];
  DeviceTypeList?: any[];
  taskType?: any[];
  dueDate?: any[];
  mapTypeOptions?: any[];
  geoFenceNameList?: any[];
  userGeofenceStatusList?: any[];
  settingTypeList?: any[];
  settingStatusList?: any[];
  trackingStatusList?: any[];
}

export interface LOCATION {
  country?: any;
  state?: any;
  city?: any;
  locality?: any;
}

export interface appliedFilter {
  dateType?: any;
  fromDate?: any;
  toDate?: any;
  fromYear?: any;
  toYear?: any;
  markerType?: string;
  userIds?: any;
  tagIds?: any[];
  leadIds?: any[];
  distributorIds?: any[];
  statusIds?: any[];
  sourceIds?: any[];
  stageIds?: any[];
  typeIds?: any[];
  territoryIds?: any[];
  categoryIds?: any[];
  referralIds?: any[];
  createdByUserIds?: any[];
  assignedToUserIds?: any[];
  location?: LOCATION;
  statusType?: any;
  orderNumber?: any;
  minValue?: string;
  maxValue?: string;
  departmentIds?: any[];
  designationIds?: any[];
  branchIds?: any[];
  roleIds?: any[];
  managerId?: any;
  qualification?: any;
  punchInType?: any;
  punchOutType?: any;
  punchInName?: any;
  punchOutName?: any;
  managerIds?: any[],
  groupId?: any;
  typeId?: any;
  locationId?: any;
  locationTypes?: any[];
  leadContacts?: any;
  byLeadStatus?: any;
  assetItemIds?: any;
  separationMode?: any;
  leaveTypeId?: any;
  meetingTypeIds?: any;
  oldDeviceTypeId?: any;
  newDeviceTypeId?: any;
  taskType?: any;
  dueDate?: any;
  allocatedDate?: any;
  returnDate?: any;
  userGeofenceStatus?: any;
  settingType?: any;
  settingStatus?: any;
  trackingStatus?: any;
}

export const EMPTY_LOCATION = {
  country: null,
  state: null,
  city: null,
  locality: null,
};

export const INITIAL_FILTERS: appliedFilter = {
  dateType: "",
  fromDate: null,
  toDate: null,
  fromYear: null,
  toYear: null,
  markerType: "",
  userIds: null,
  tagIds: [],
  leadIds: [],
  distributorIds: [],
  statusIds: [],
  sourceIds: [],
  stageIds: [],
  typeIds: [],
  territoryIds: [],
  referralIds: [],
  createdByUserIds: [],
  assignedToUserIds: [],
  categoryIds: [],
  statusType: null,
  location: EMPTY_LOCATION,
  minValue: "",
  maxValue: "",
  orderNumber: "",
  departmentIds: [],
  designationIds: [],
  branchIds: [],
  roleIds: [],
  managerId: null,
  qualification: null,
  punchInType: null,
  punchOutType: null,
  punchInName: null,
  punchOutName: null,
  managerIds: [],
  groupId: null,
  byLeadStatus: null,
  typeId: null,
  locationId: null,
  locationTypes: [],
  leadContacts: null,
  assetItemIds: null,
  separationMode: null,
  leaveTypeId: "",
  meetingTypeIds: [],
  oldDeviceTypeId: "",
  newDeviceTypeId: "",
  taskType: "",
  dueDate: "",
  userGeofenceStatus: null,
  allocatedDate: null,
  returnDate: null,
  settingType: null,
  settingStatus: null,
  trackingStatus: null,
};

export type ClearFilterKey =
  | keyof appliedFilter
  | "date"
  | "year"
  | "location";

export type ClearFilterFn = (
  filter: ClearFilterKey,
  value?: string,
  index?: number
) => void;